import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initNative } from "@/lib/native";

// Suppress CRA dev-overlay for well-known "silent" axios rejections
// (e.g. 403 EMAIL_NOT_VERIFIED on dashboard fetches for unverified users).
// The dashboard renders its own friendly banner from /api/auth/me; the
// downstream 403s are expected and should not block the UI.
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (e) => {
    if (e?.reason?.silent) e.preventDefault();
  });
}

// Configure native shell (status bar, splash, etc.) — no-op on web.
initNative();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
